import React from 'react';
import styled from 'styled-components';
import {
  PageControlBtnBox,
  PageControlCircle,
  PrevNextBtnSec,
} from '../sideType/DetailStyle';
import Icon from '@components/dataDisplay/Icons/Icon';
import { useDocument } from '@nandorojo/swr-firestore';
import { IpostingItem } from '@typings/posting/posting.interface';

const Div = styled.div``;

type Props = {
  collectionPath: string;
  prevID: string | null;
  nextID: string | null;
  handlePrev;
  handleNext;
};
function PrevNextBtn({
  collectionPath,
  prevID,
  nextID,
  handlePrev,
  handleNext,
}: Props) {
  const { data: prevData } = useDocument<IpostingItem>(
    `${collectionPath}/${prevID}`,
    { listen: true },
  );

  const { data: nextData } = useDocument<IpostingItem>(
    `${collectionPath}/${nextID}`,
    { listen: true },
  );

  return (
    <PrevNextBtnSec>
      {prevID && (
        <PageControlBtnBox className="prevDoc" onClick={handlePrev}>
          <PageControlCircle className="circleBtn prevAni">
            <Icon name="LeftArrowO" color="var(--subColor)" />
          </PageControlCircle>
          <div>
            <div className="docLabel">이전 글</div>
            <div className="prevTitle">{prevData && prevData.title}</div>
          </div>
        </PageControlBtnBox>
      )}
      {nextID && (
        <PageControlBtnBox className="nextDoc" onClick={handleNext}>
          <div className="contentSec">
            <div className="docLabel">다음 글</div>
            <div className="prevTitle">{nextData && nextData.title}</div>
          </div>
          <PageControlCircle className="circleBtn nextAni">
            <Icon name="RightArrowO" color="var(--subColor)" />
          </PageControlCircle>
        </PageControlBtnBox>
      )}
    </PrevNextBtnSec>
  );
}

export default PrevNextBtn;
